<h4 class="mb-2">{{'ForgotPassword' | translate}}</h4>
<!-- <p class="mb-4">{{'ForgotPassword.Email' | translate}}</p> -->
<div class="mb-3 validation-alert">
  <label for="emailAddress" class="form-label">{{'Email' | translate}}</label>
  <input type="text" class="form-control text-start" dir="ltr" placeholder="{{'EnterEmail' | translate}}" autofocus
    (keyup)="checkValidation()" [(ngModel)]="emailAddress">
  <div class="alert alert-danger" *ngIf="validateMessage.length>0">
    <span class="help-block" *ngFor="let item of validateMessage">
      {{ item }}
    </span>
  </div>
</div>
<button class="btn btn-primary d-grid w-100" type="submit" [disabled]="validateMessage.length>0"
  (click)="onSubmit()">{{'Send' | translate}}</button>
<div class="text-center">
  <a routerLink="/login" class="d-flex align-items-center justify-content-center">
    <i class="bx bx-chevron-left scaleX-n1-rtl"></i>
    {{'ReturnToLogin' | translate}}
  </a>
</div>